import { render, staticRenderFns } from "./invitationForm.vue?vue&type=template&id=6a24f211&scoped=true"
import script from "./invitationForm.vue?vue&type=script&lang=js"
export * from "./invitationForm.vue?vue&type=script&lang=js"
import style0 from "./invitationForm.vue?vue&type=style&index=0&id=6a24f211&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24f211",
  null
  
)

export default component.exports